import { render, staticRenderFns } from "./AssignmentRemoveIcon.vue?vue&type=template&id=9cfc1130&scoped=true&"
import script from "./AssignmentRemoveIcon.vue?vue&type=script&lang=js&"
export * from "./AssignmentRemoveIcon.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRemoveIcon.vue?vue&type=style&index=0&id=9cfc1130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfc1130",
  null
  
)

export default component.exports